import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const CITIES = [
  { name: "Jakarta", q: "Jakarta", img: "https://images.unsplash.com/photo-1679239108020-aca50acd5f00?crop=entropy&cs=srgb&fm=jpg&q=80&w=800" },
  { name: "Yogyakarta", q: "Yogyakarta", img: "https://images.unsplash.com/photo-1652953445949-125a4ecf8d5b?crop=entropy&cs=srgb&fm=jpg&q=80&w=800" },
  { name: "Bandung", q: "Bandung", img: "https://images.unsplash.com/photo-1707993467310-a5b2bb858d68?crop=entropy&cs=srgb&fm=jpg&q=80&w=800" },
  { name: "Bali", q: "Bali", img: "https://images.unsplash.com/photo-1558005530-a7958896ec60?crop=entropy&cs=srgb&fm=jpg&q=80&w=800" },
  { name: "Surabaya", q: "Surabaya", img: "https://images.unsplash.com/photo-1557224646-39ca3fa3ef05?crop=entropy&cs=srgb&fm=jpg&q=80&w=800" },
  { name: "Semarang", q: "Semarang", img: "https://images.unsplash.com/photo-1652100591395-6d512bfaf5bb?crop=entropy&cs=srgb&fm=jpg&q=80&w=800" },
  { name: "Medan", q: "Medan", img: "https://images.unsplash.com/photo-1713768252234-b87917609ce0?crop=entropy&cs=srgb&fm=jpg&q=80&w=800" },
];

export default function PopularCitiesSection() {
  const navigate = useNavigate();
  const go = (c) => navigate(`/search?q=${encodeURIComponent(c.q)}`);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24" data-testid="popular-cities-section">
      <div className="max-w-2xl mb-10">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">Kota Favorit</span>
        <h2 className="mt-3 font-heading text-3xl lg:text-4xl font-semibold tracking-tight">
          Pencarian Kota Populer
        </h2>
        <p className="mt-3 text-base text-muted-foreground">
          Jelajahi hunian di kota-kota favorit pilihanmu.
        </p>
      </div>

      {/* Mobile: horizontal swipe. Desktop: grid. */}
      <div className="flex gap-4 overflow-x-auto pb-4 -mx-1 px-1 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden sm:grid sm:grid-cols-3 sm:overflow-visible sm:mx-0 sm:px-0 lg:grid-cols-4">
        {CITIES.map((c, i) => (
          <motion.button
            type="button"
            key={c.name}
            onClick={() => go(c)}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ delay: Math.min(i, 6) * 0.05, duration: 0.4 }}
            data-testid={`city-card-${c.name.toLowerCase()}`}
            className="group relative shrink-0 w-[46%] sm:w-auto aspect-[3/4] overflow-hidden rounded-2xl shadow-sm hover:shadow-xl transition-[transform,box-shadow] duration-300 hover:-translate-y-1 cursor-pointer text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
          >
            <img
              src={c.img}
              alt={`Hunian di ${c.name}`}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-4">
              <h3 className="font-heading text-lg sm:text-xl font-semibold text-white drop-shadow-sm">{c.name}</h3>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-white/85">
                <MapPin size={12} className="shrink-0" /> Hunian di {c.name}
              </p>
            </div>
          </motion.button>
        ))}
      </div>
    </section>
  );
}
